import { FC } from 'react'
import iconModule from '@/assets/img/icons/clock.png'
import { TypeIcon } from '@/components/Atoms/Icons/types'

const Icon: FC<TypeIcon> = ({ width = 25, height = 25 }) => {
  return (
    <img
      src={iconModule}
      alt='Clock'
      width={width}
      height={height}
    />
  )
}

export default Icon
